export default __webpack_public_path__ + "static/media/dropdown2.0881f917.svg";